// What gas a cylinder carries — the backend's utils/gases.js (keep the two, and manifold-pwa's copy, in sync).
// Contributions say it since 2026-11-02; older ones have none ("Sin dato").
export const GASES = ['oxigeno_industrial', 'oxigeno_medicinal', 'nitrogeno'];
export const GAS_LABEL = {
  oxigeno_industrial: 'Oxígeno Industrial',
  oxigeno_medicinal: 'Oxígeno Medicinal',
  nitrogeno: 'Nitrógeno',
};
export const gasLabel = (gas) => GAS_LABEL[gas] || 'Sin dato';

// Caribbean Gas / IntMed's own stock (CGC's cylinders): its empties say who brought them back, its despachos who gets
// them (backend utils/cgcTanks.js).
export const CGC_CLIENT = 'Caribbean Gas Company / IntMed';
export const isCgcClient = (name) =>
  String(name || '').trim().toLowerCase().replace(/\s+/g, ' ') === CGC_CLIENT.toLowerCase();
